import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  Grid,
  Container,
  Paper,
  Button,
  Backdrop,
  CircularProgress,
  Typography,
  Divider,
  Stack,
  Chip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import { getDataRequest } from "../../helper/AxiosHelper";

function DetailRow({ label, value }) {
  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1" sx={{ mt: 0.5, wordBreak: "break-all" }}>
        {value ?? "-"}
      </Typography>
    </Grid>
  );
}

export default function Component() {
  const { dashboardID } = useParams();
  const navigate = useNavigate();

  const [isDataPadding, setDataPadding] = useState(true);
  const [record, setRecord] = useState(null);

  useEffect(() => {
    getDataRequest(`dashboardVideo/show/${dashboardID}`, (isSuccess, data) => {
      if (!isSuccess) {
        console.log("Data not found with id - " + dashboardID);
        setDataPadding(false);
        return;
      }
      setRecord(data.record);
      setDataPadding(false);
    });
  }, []);

  return (
    <Container maxWidth={"lg"}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isDataPadding}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <CommonBreadcrumb dbData={record ? { name: record.title_zh } : undefined} />

      <Paper sx={{ px: 3, py: 5, mt: 3 }} elevation={3}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ mb: 3 }}
        >
          <Typography variant="h5">影片詳情</Typography>
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={() => navigate(`/dashboardVideo/update/${dashboardID}`)}
          >
            編輯
          </Button>
        </Stack>

        <Divider sx={{ mb: 3 }} />

        {record && (
          <Grid container rowSpacing={3} columnSpacing={2}>
            <DetailRow label="標題 (中文)" value={record.title_zh} />
            <DetailRow label="Title (English)" value={record.title_en} />
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">
                影片 URL
              </Typography>
              <Typography
                variant="body1"
                sx={{ mt: 0.5, wordBreak: "break-all" }}
              >
                {record.video_url ? (
                  <a href={record.video_url} target="_blank" rel="noreferrer">
                    {record.video_url}
                  </a>
                ) : (
                  "-"
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">
                描述 Description
              </Typography>
              <Typography variant="body1" sx={{ mt: 0.5, whiteSpace: "pre-wrap" }}>
                {record.description || "-"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                狀態 Status
              </Typography>
              <Stack direction="row" sx={{ mt: 0.5 }}>
                <Chip
                  label={record.status === 1 ? "啟用 Active" : "停用 Inactive"}
                  color={record.status === 1 ? "success" : "default"}
                  size="small"
                />
              </Stack>
            </Grid>
            <DetailRow label="顯示順序 Display Order" value={record.display_order} />
          </Grid>
        )}
      </Paper>
    </Container>
  );
}
